import store from "@/store/store";
export {
  fetchList,
  fetchData,
  storeData,
  deleteData,
  downloadPdf,
  downloadDatabase,
  downloadExtraFile,
  downloadSha256,
  authentContact,
  changePassword,
  resetPassword,
  viewPdf
};

function getReverseProxyURL() {
  return "" + process.env.VUE_APP_REVERSE_PROXY + "/";
}

// Return the correct Authorization header value, ready to use for requests
function getAutorisationHeaderValue() {
  return store.getters.getCompiledAuthentTokenValue;
  //"Basic " + Buffer.from(username + ":" + password).toString("base64")
}

/**
 *Load the 500 first rows from a joget datalist thanks to joget JSON API. It will return only the fields presents in the list (the hidden and the non-hidden ones)
 *@param {appId} is the id of the joget app in which there is the list you want to load
 *@param {listId} is the id of the joget datalist you want to load
 *@param {filters} is a list of filter. Each filter is a string formated as following : columnName=value or columnName>value
 *@return a promise which resolving value is the data array
 */
async function fetchList(appId, listId, filters) {
  if (typeof filters == "string") {
    filters = [filters];
  }
  //Parsing filters
  var filtersRequest = "";
  if (filters != undefined) {
    for (var i = 0; i < filters.length; i++) {
      filtersRequest = filtersRequest + "&";
      filtersRequest += filters[i];
    }
  }
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  requestHeader.append("Content-Type", "text/plain");
  //Setting request configuration
  var requestInit = {
    method: "GET",
    headers: requestHeader,
    mode: "cors",
    redirect: "follow",
    credentials: "include"
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "jw/web/json/data/list/" +
    appId +
    "/" +
    listId +
    "?rows=" +
    process.env.VUE_APP_NB_MAX_ROW +
    filtersRequest;
  return fetch(new Request(requestURL, requestInit)).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      // eslint-disable-next-line no-console
      console.log(
        "Network Error. Status : " + response.status + " " + response.statusText
      );
    }
  });
}

/**
 *Load a specific row from joget database thanks to joget JSON API.
 *@param {appId} is the id of the joget app in which there is the list you want to load
 *@param {formId} is the id of the joget form connected to the table in which you want to load data
 *@param {id} is the id of the row you want to load
 */
function fetchData(appId, formId, id) {
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  requestHeader.append("Content-Type", "application/json");
  //Setting request configuration
  var requestInit = {
    method: "GET",
    headers: requestHeader,
    mode: "cors",
    redirect: "follow",
    credentials: "include"
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "jw/web/json/data/form/load/" +
    appId +
    "/" +
    formId +
    "/" +
    id;
  return fetch(new Request(requestURL, requestInit)).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      // eslint-disable-next-line no-console
      console.log(
        "Network Error. Status : " + response.status + " " + response.statusText
      );
    }
  });
}

/**
 *Store the variable datas in joget database thanks to joget JSON API.
 *@param {appId} is the id of the joget app in which there is the list you want to load
 *@param {formId} is the id of the joget form connected to the table in which you want to store data
 *@param {id} is the id of the row in which you want to store the data, put an empty string to store data in a new row which will have it's own new id generated by joget
 *@param {data} is a list that is filled with objects {id : "", value : ""} ex: data = [{id : "c_regions",value : "USA;AFR"},{id : "c_name",value : "a strange name"}]
 */
function storeData(appId, formId, id, data) {
  //Setting body at x-www-form-urlencoded format
  var body = "";
  data.forEach(element => {
    body = body + element.id + "=" + encodeURIComponent(element.value) + "&";
  });
  body = body.substring(0, body.length - 1);
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  requestHeader.append("Content-Type", "application/x-www-form-urlencoded");
  //Setting request configuration
  var requestInit = {
    method: "POST",
    headers: requestHeader,
    mode: "cors",
    redirect: "follow",
    credentials: "include",
    body: body
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "jw/web/json/data/form/store/" +
    appId +
    "/" +
    formId +
    "/" +
    id;

  return fetch(new Request(requestURL, requestInit)).then(response => {
    if (!response.ok) {
      // eslint-disable-next-line no-console
      console.log(
        "Network Error. Status : " + response.status + " " + response.statusText
      );
    }
    return response;
  });
}

function deleteData(appId, formId, id) {
  //Setting body at x-www-form-urlencoded format
  var requestHeader = new Headers();
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  requestHeader.append("Content-Type", "application/json");
  //Setting request configuration
  var requestInit = {
    method: "POST",
    headers: requestHeader,
    mode: "cors",
    redirect: "follow",
    credentials: "include"
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "jw/web/json/data/form/delete/" +
    appId +
    "/" +
    formId +
    "/" +
    id;
  return fetch(new Request(requestURL, requestInit)).then(response => {
    if (!response.ok) {
      // eslint-disable-next-line no-console
      console.log(
        "Network Error. Status : " + response.status + " " + response.statusText
      );
    }
    return response;
  });
}
/**
 *Download a PDF Generated from given bulletin informations thanks to PDF Generation WebService
 *@param {bulletinId} is the bulletin id of the bulletin you want to download
 *@param {bulletinType} is the bulletin type of the bulletin you want to download
 */
async function downloadPdf(bulletinId, bulletinType) {
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Accept", "application/pdf");
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  //Setting request configuration
  var requestInit = {
    method: "GET",
    mode: "cors",
    redirect: "follow",
    credentials: "omit",
    headers: requestHeader
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "BulletinGenerationService/generate_pdf_bulletin/customer/?bulletinId=" +
    bulletinId +
    "&bulletinType=" +
    bulletinType;
  let responseHeaders;
  return fetch(new Request(requestURL, requestInit))
    .then(response => {
      if (response.ok) {
        responseHeaders = response.headers.get("Content-Disposition");
        return response.blob();
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "Network Error. Status : " +
            response.status +
            " " +
            response.statusText
        );
      }
    })
    .then(file => {
      // Once the file is downloaded, open a new window with the PDF
      // Remember to allow the POP-UPS in your browser
      // Generate file download directly in the browser !
      var FileSaver = require("file-saver");
      var pdfName = responseHeaders.split('filename="')[1];
      pdfName = pdfName.substring(0, pdfName.length - 1);
      FileSaver.saveAs(file, pdfName);
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
}

/**
 *Download a database file
 *@param {row} is the row who contain data about database
 *@param {user} contain data about logged contact
 *@param {customer} contain data about current customer
 */
async function downloadDatabase(row, user, customer) {
  var id = row.id;
  var databaseFile = row.databaseName;
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Accept", "application/*");
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  //Setting request configuration
  var requestInit = {
    method: "GET",
    mode: "cors",
    redirect: "follow",
    credentials: "omit",
    headers: requestHeader
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "jw/web/json/plugin/" +
    process.env.VUE_APP_DOWNLOAD_DATABASE_PLUGIN_CLASS_NAME +
    "/service/?primaryKey=" +
    id +
    "&fileName=" +
    databaseFile;
  return fetch(new Request(requestURL, requestInit))
    .then(response => {
      if (response.ok) {
        return response.blob();
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "Network Error. Status : " +
            response.status +
            " " +
            response.statusText
        );
      }
    })
    .then(file => {
      // Generate file download directly in the browser !
      var FileSaver = require("file-saver");
      FileSaver.saveAs(file, databaseFile);
      //Add an entry in database download history
      var moment = require("moment");
      var curentDateFormated = moment().format("YYYY-MM-DD");
      var data = [
        { id: "customerId", value: customer.id },
        { id: "databaseIndicator", value: row.c_databaseIndicator },
        { id: "airac_cycle", value: row.c_formattedAirac },
        { id: "version", value: row.c_version },
        { id: "dateOfDownload", value: curentDateFormated },
        { id: "contactThatDownload", value: user.username }
      ];
      storeData(
        process.env.VUE_APP_DATABASES_APP_ID,
        "" + process.env.VUE_APP_DATABASES_FORM_HISTORY,
        "",
        data
      )
        .then(response => {
          //check if response contains an ID
          if (response != undefined || response != "") {
            row.loadingStatus = false;
          } else {
            // eslint-disable-next-line no-console
            console.log("Error while storing the download event");
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
}

/**
 *Download a Extra File link to a database
 *@param {row} is the row who contain data about database
 *@param {user} contain data about logged contact
 *@param {customer} contain data about current customer
 */
async function downloadExtraFile(row) {
  var id = row.id;
  var extraFile = row.extraFileName;
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Accept", "application/*");
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  //Setting request configuration
  var requestInit = {
    method: "GET",
    mode: "cors",
    redirect: "follow",
    credentials: "omit",
    headers: requestHeader
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "jw/web/json/plugin/" +
    process.env.VUE_APP_DOWNLOAD_DATABASE_PLUGIN_CLASS_NAME +
    "/service/?primaryKey=" +
    id +
    "&fileName=" +
    extraFile;
  let responseHeaders;
  return fetch(new Request(requestURL, requestInit))
    .then(response => {
      if (response.ok) {
        responseHeaders = response.headers.get("Content-Disposition");
        return response.blob();
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "Network Error. Status : " +
            response.status +
            " " +
            response.statusText
        );
      }
    })
    .then(file => {
      // Once the file is downloaded, open a new window with the PDF
      // Remember to allow the POP-UPS in your browser
      // Generate file download directly in the browser !
      var FileSaver = require("file-saver");
      FileSaver.saveAs(file, extraFile);
      row.loadingStatus = false;
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
}

/**
 *Download a Extra File link to a database
 *@param {row} is the row who contain data about database
 *@param {user} contain data about logged contact
 *@param {customer} contain data about current customer
 */
async function downloadSha256(row) {
  var id = row.id;
  var shaFile = row.sha256fileName;
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Accept", "application/*");
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  //Setting request configuration
  var requestInit = {
    method: "GET",
    mode: "cors",
    redirect: "follow",
    credentials: "omit",
    headers: requestHeader
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "jw/web/json/plugin/" +
    process.env.VUE_APP_DOWNLOAD_DATABASE_PLUGIN_CLASS_NAME +
    "/service/?primaryKey=" +
    id +
    "&fileName=" +
    shaFile;
  let responseHeaders;
  return fetch(new Request(requestURL, requestInit))
    .then(response => {
      if (response.ok) {
        responseHeaders = response.headers.get("Content-Disposition");
        return response.blob();
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "Network Error. Status : " +
            response.status +
            " " +
            response.statusText
        );
      }
    })
    .then(file => {
      // Once the file is downloaded, open a new window with the PDF
      // Remember to allow the POP-UPS in your browser
      // Generate file download directly in the browser !
      var FileSaver = require("file-saver");
      FileSaver.saveAs(file, shaFile);
      row.loadingStatus = false;
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
}

/**
 *Return false if the authent failed, true if it work
 *@param {email} is the email of the contact you want to authentificated with
 *@param {password} is the password of the contact you want to authentificated with
 */
async function authentContact(email, password) {
  //Setting body at x-www-form-urlencoded format
  var body =
    "username=" +
    encodeURIComponent(email) +
    "&password=" +
    encodeURIComponent(password) +
    "&grant_type=password";
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Content-Type", "application/x-www-form-urlencoded");
  //Setting request configuration
  var requestInit = {
    method: "POST",
    headers: requestHeader,
    mode: "cors",
    redirect: "follow",
    credentials: "include",
    body: body
  };
  //Setting request URL
  var authentSucced = false;
  var requestURL = getReverseProxyURL() + "authentification/token";
  await fetch(new Request(requestURL, requestInit))
    .then(response => {
      if (!response.ok) {
        // eslint-disable-next-line no-console
        console.log(
          "Network Error. Status : " +
            response.status +
            " " +
            response.statusText
        );
      } else {
        authentSucced = true;
      }
      return response.json();
    })
    .then(data => {
      if (authentSucced) {
        store.dispatch("setAuthentToken", {
          value: data.access_token,
          type: data.token_type,
          duration: data.expires_in
        });
      } else {
        // eslint-disable-next-line no-console
        console.log("Error : " + data.error_description);
      }
    });
  return authentSucced;
}

/**
 *Return false if the update of password failed, true if it work
 *@param {UserName} is the email of the contact you want to authentificated with
 *@param {OldPassword} is the old password, is this field will be change
 *@param {NewPassword} is the new password
 */
function changePassword(UserName, OldPassword, NewPassword) {
  var body = JSON.stringify({
    UserName: UserName,
    OldPassword: OldPassword,
    NewPassword: NewPassword
  });
  var requestHeader = new Headers();
  requestHeader.append("Content-Type", "application/json");
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  //Setting request configuration
  var options = {
    method: "POST",
    mode: "cors",
    credentials: "include",
    headers: requestHeader,
    redirect: "follow",
    body: body
  };
  return fetch(
    getReverseProxyURL() + "authentification/ChangePassword",
    options
  ).then(response =>
    response.json().then(response => {
      var requestReponse = { ok: true, message: response };
      return requestReponse;
    })
  );
}

/**
 *Call the joget webservice for reset the password account
 *@param {email} is the email of the account that will have its password reset
 **/
async function resetPassword(email) {
  //Setting body at x-www-form-urlencoded format
  var body = "UserName=" + encodeURIComponent(email);
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Content-Type", "application/x-www-form-urlencoded");
  //Setting request configuration
  var requestInit = {
    method: "POST",
    headers: requestHeader,
    mode: "cors",
    redirect: "follow",
    credentials: "include",
    body: body
  };
  //Setting request URL
  var authentSucced = false;
  var requestURL =
    getReverseProxyURL() +
    "/jw/web/json/plugin/" +
    "com.navblue.joget.ddt.SendResetPasswordMail/service";

  await fetch(new Request(requestURL, requestInit)).then(response => {
    if (!response.ok) {
      // eslint-disable-next-line no-console
      console.log(
        "Network Error. Status : " + response.status + " " + response.statusText
      );
    } else {
      authentSucced = true;
    }
    return authentSucced;
  });
  return authentSucced;
}

/**
 *View a PDF Generated from given bulletin informations thanks to PDF Generation WebService
 *@param {bulletinId} is the bulletin id of the bulletin you want to view
 *@param {bulletinType} is the bulletin type of the bulletin you want to view
 */
async function viewPdf(bulletinId, bulletinType) {
  //Setting Headers
  var requestHeader = new Headers();
  requestHeader.append("Accept", "application/pdf");
  requestHeader.append("Authorization", getAutorisationHeaderValue());
  //Setting request configuration
  var requestInit = {
    method: "GET",
    mode: "cors",
    redirect: "follow",
    credentials: "omit",
    headers: requestHeader
  };
  //Setting request URL
  var requestURL =
    getReverseProxyURL() +
    "BulletinGenerationService/generate_pdf_bulletin/customer/?bulletinId=" +
    bulletinId +
    "&bulletinType=" +
    bulletinType;
  let responseHeaders;
  return fetch(new Request(requestURL, requestInit))
    .then(response => {
      if (response.ok) {
        responseHeaders = response.headers.get("Content-Disposition");
        return response.blob();
      } else {
        // eslint-disable-next-line no-console
        console.log(
          "Network Error. Status : " +
            response.status +
            " " +
            response.statusText
        );
      }
    })
    .then(file => {
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error(error);
    });
}
